// ── A tiny in-page bus so other screens can open the copilot ────────────────
// The bubble is mounted once in routes/__root.tsx; the dashboard brief (and
// later the KPI tiles) live elsewhere in the tree. Rather than lift the
// bubble's state into a context the whole app re-renders on, callers publish
// a command here and the mounted bubble, if any, picks it up. When no bubble
// is mounted (gate off), a command is simply dropped: the callers only render
// their "Ask AI" affordances when the gate says the bubble is there.

export interface CopilotCommand {
  /** Text to put in the composer. */
  seed?: string
  /** Send `seed` as a message right away instead of leaving it in the box. */
  send?: boolean
}

type Listener = (cmd: CopilotCommand) => void

const listeners = new Set<Listener>()

export function openCopilot(cmd: CopilotCommand = {}): void {
  for (const l of listeners) l(cmd)
}

/** Subscribe to open commands; returns the unsubscribe. */
export function onCopilotCommand(listener: Listener): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

/** For tests. */
export function copilotListenerCount(): number {
  return listeners.size
}
